import { UMR } from './tokens';

/**
 * Correctifs de style locaux au prototype.
 * UrbanMap force le texte d'aide des champs en noir (`UMForm`), ce qui laisse croire
 * que le champ est déjà saisi : on le repasse en gris, comme sur les écrans UM récents.
 */
export function PlanFormStyles() {
  return (
    <style>{`
      input.um-input::placeholder { color: ${UMR.textPlaceholder}; opacity: 1; }
      .plan-panel input::placeholder, .plan-panel textarea::placeholder { color: ${UMR.textPlaceholder}; opacity: 1; }
    `}</style>
  );
}
